import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { queries } from "../lib/api";
import { PageHeader } from "../components/Workspace";
import { ConnectionOversight } from "../components/ConnectionOversight";
export const Route = createFileRoute("/sessions")({ component: SessionsPage });
function SessionsPage() {
  const me = useQuery(queries.me());
  const admin = me.data?.admin === true || me.data?.roles.includes("administrator") === true;
  return (
    <>
      <PageHeader
        title="Sessions"
        description="Review live connections and device activations. Revoke managed access when required."
      />
      {admin || me.data?.roles.includes("auditor") ? (
        <ConnectionOversight admin={admin} />
      ) : (
        <p>Administrator or auditor access is required to review live sessions.</p>
      )}
    </>
  );
}
